import React, { useEffect, useRef, useState } from "react";
import {
  RiAdminFill,
  RiDeleteBack2Fill,
  RiDeleteBin2Fill,
  RiPencilFill,
  RiDragMove2Fill,
} from "react-icons/ri";
import { useClickOutside } from "../../../../../components/Hooks/useClickOutside";
import Questionnaire from "../../../../../libs/api/services/Questionnaire";
import './Section.scss'
export default function SectionsDropDown({ questionnaireId, onUpdate }) {
  const [section, setSections] = useState([]);
  const dragItem = useRef();
  const dragOverItem = useRef();
  const [open, setOpen] = useState(false);
  const menuRef = useRef();
  const [draggingIdx, setDraggingIdx] = useState(null);

  const loadQuesitonnaireSections = async () => {
    setSections(
      await Questionnaire.ListQuestionnaireSections(questionnaireId).catch(
        (err) => {
          console.error("Error loading questionnaire sections:", err);
        }
      )
    );
  };

  useEffect(() => {
    loadQuesitonnaireSections();
  }, []);

  // Drag and drop handlers
  const handleDragStart = (index) => {
    dragItem.current = index;
    setDraggingIdx(index);
  };

  const handleDragEnter = (index) => {
    dragOverItem.current = index;
  };

  const handleDragEnd = async () => {
    if (dragItem.current === undefined || dragOverItem.current === undefined) {
      setDraggingIdx(null);
      return;
    }
    const items = [...section];
    const draggedItem = items[dragItem.current];
    items.splice(dragItem.current, 1);
    items.splice(dragOverItem.current, 0, draggedItem);
    setSections(items);
    // Update order in API
    try {
      for (let i = 0; i < items.length; i++) {
        await Questionnaire.UpdateQuestionnaireSection(items[i].id, {
          ...items[i],
          order: i
        });
      }
      if (onUpdate) onUpdate();
    } catch (err) {
      console.error("Error updating section order:", err);
    }
    dragItem.current = undefined;
    dragOverItem.current = undefined;
    setDraggingIdx(null);
  };

  const handleAddSection = (e) => {
    e.preventDefault();
    console.log("Adding section", e.target.elements);
    const sectionName = e.target.elements[0].value;
    if (sectionName) {
      Questionnaire.CreateQuestionnaireSection(questionnaireId, {
        name: sectionName,
      })
        .then(() => {
          loadQuesitonnaireSections();
          if(onUpdate)onUpdate()
        })
        .catch((err) => {
          console.error("Error adding section:", err);
        });
      e.target.reset();
    }
    setOpen(false);
  };

  const handleEditSection = (e) => {
    e.preventDefault();
    // Convert form data to object
    const formData = new FormData(e.target);
    const sectionData = Object.fromEntries(formData);

    const findElement = section.find((el) => el.id === sectionData.id);
    if (!findElement) {
      console.error("Section not found:", sectionData.id);
      return;
    }
    console.log("Editing section", findElement);
    if (sectionData.name) {
      Questionnaire.UpdateQuestionnaireSection(findElement.id, {
        ...findElement,
        name: sectionData.name,
      })
        .then(() => {
          loadQuesitonnaireSections();
          if(onUpdate)onUpdate()
        })
        .catch((err) => {
          console.error("Error editing section:", err);
        });
      e.target.reset();
    }
    setOpen(false);
  };
  const handleDeleteSection = (sectionId) => {
    Questionnaire.RemoveQuestionnaireSection(sectionId)
      .then(() => {
        loadQuesitonnaireSections();
        if(onUpdate)onUpdate()
      })
      .catch((err) => {
        console.error("Error deleting section:", err);
      });
  };

  useClickOutside(menuRef, () => setOpen(false));
  return (
    <div ref={menuRef}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="btn btn-secondary dropdown-toggle"
      >
        <RiAdminFill /> Sections
      </button>
      {open && (
        <div
          className="dropdown-menu show"
          style={{ position: "absolute", right: 0, width: "350px" }}
        >
          <form onSubmit={handleAddSection} className="d-flex p-2">
            <input
              name="sectionName"
              className="form-control"
              type="text"
              placeholder="New Section Name"
            />
            <button className="btn btn-xs" type="submit">
              Add Section
            </button>
          </form>
          {section &&
            section.length > 0 &&
            section.map((sec, idx) => (
              <form
                draggable
                className={`d-flex p-2 align-items-center${draggingIdx === idx ? " bg-dragging" : ""}`}
                onSubmit={handleEditSection}
                key={sec.id}
                onDragStart={() => handleDragStart(idx)}
                onDragEnter={() => handleDragEnter(idx)}
                onDragEnd={handleDragEnd}
                style={{ cursor: "move" }}
              >
                <span style={{ marginRight: "8px", cursor: "grab" }}>
                  <RiDragMove2Fill size={20} />
                </span>
                <input type="hidden" name="id" value={sec.id} />
                <input
                  className="form-control flex-grow-1"
                  type="text"
                  name="name"
                  placeholder="Section Name"
                  defaultValue={sec.name}
                />
                <button className="btn btn-xs" type="submit">
                  <RiPencilFill />
                </button>
                <button
                  className="btn btn-xs"
                  type="button"
                  onClick={() => handleDeleteSection(sec.id)}
                >
                  <RiDeleteBin2Fill />
                </button>
              </form>
            ))}
        </div>
      )}
    </div>
  );
}
